// src/redux/thunks/collectionThunk.js
import axiosInstance from "../../utils/axiosInterceptor";
import { reducersActions } from "./new-actions";

const {
    FETCH_COLLECTIONS_REQUEST,
    FETCH_COLLECTIONS_SUCCESS,
    FETCH_COLLECTIONS_FAILURE,
} = reducersActions;

export const fetchCollections = () => async (dispatch) => {
  dispatch({ type: FETCH_COLLECTIONS_REQUEST });
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL_VMS}/api/v1/collections`);
    dispatch({
      type: FETCH_COLLECTIONS_SUCCESS,
      payload: response.data,
    });
    // console.log(response,"response")
  } catch (error) {
    dispatch({
      type: FETCH_COLLECTIONS_FAILURE,
      payload: error.message,
    });
  }
};
export const fetchCollectionsv3 = () => async (dispatch) => {
  dispatch({ type: FETCH_COLLECTIONS_REQUEST });
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL_VMS}/api/v3/collections/collectionData`);
    dispatch({
      type: FETCH_COLLECTIONS_SUCCESS,
      payload: response.data,
    });
    // console.log(response,"response")
  } catch (error) {
    dispatch({
      type: FETCH_COLLECTIONS_FAILURE,
      payload: error.message,
    });
  }
};
